import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandingContext = createContext(null);
const DEFAULT = { app_name: "ZOA Mission Control", tagline: "Mission Control", logo: null };

function applyDocument(b) {
  if (b?.app_name) document.title = b.app_name;
  if (b?.logo) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = b.logo;
  }
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/branding");
      const b = { ...DEFAULT, ...r.data };
      setBranding(b);
      applyDocument(b);
    } catch (e) { /* keep defaults */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <BrandingContext.Provider value={{ branding, reloadBranding: load, setBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext) || { branding: DEFAULT, reloadBranding: () => {}, setBranding: () => {} };
}
